import React, { useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'
import { useLanguage } from '../../Context/LanguageContext'

// Import Assets
import logoLight from '../../Assets/img/imigo-logo.png'

const FooterImigo = () => {
  const { setFooterHeight } = useContext(GlobalContext);
  const { getLocalizedPath } = useLanguage();
  const footerRef = useRef(null);

  useEffect(() => {
    const measure = () => {
      const el = footerRef.current
      if (el) setFooterHeight(el.offsetHeight)
    }
    const t = setTimeout(measure, 1000)
    const onResize = () => setTimeout(measure, 1000)
    window.addEventListener('resize', onResize)
    return () => {
      clearTimeout(t)
      window.removeEventListener('resize', onResize)
    }
  }, [setFooterHeight])

  return (
    <footer ref={footerRef} className="footer-imigo py-12 md:py-[60px] bg-darkgray text-white">
      <Container className="px-4">
        <Row className="justify-content-between g-4">
          <Col lg={4} md={6} className="mb-[30px] mb-md-0">
            <Link to={getLocalizedPath('/')} className="mb-[20px] inline-block">
              <img src={logoLight} alt="Imigo Logo" className="h-[52px] md:h-[60px] w-auto" />
            </Link>
            <p className="mb-[20px] text-white/90 leading-relaxed max-w-md">
              Imigo is your smart migration assistant, connecting you with resources, communities, and tools to make your migration journey smoother and more human.
            </p>
            <div className="social-icons flex flex-wrap gap-2">
              <a
                href="https://www.instagram.com/imigoapp/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Imigo on Instagram"
                className="footer-social-icon"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/hani-eisapour/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Hani Eisapour on LinkedIn"
                className="footer-social-icon"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </Col>
          <Col lg={2} md={6} className="mb-[30px] mb-md-0">
            <h6 className="font-bold mb-[20px] text-white">Quick Links</h6>
            <ul className="pl-0 list-none">
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/')} className="text-white/90 hover:text-neonorange transition-all duration-300">Home</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/articles')} className="text-white/90 hover:text-neonorange transition-all duration-300">Articles</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/businesses')} className="text-white/90 hover:text-neonorange transition-all duration-300">Businesses</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/events')} className="text-white/90 hover:text-neonorange transition-all duration-300">Events</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/marketplace')} className="text-white/90 hover:text-neonorange transition-all duration-300">Marketplace</Link>
              </li>
            </ul>
          </Col>
          <Col lg={2} md={6} className="mb-[30px] mb-md-0">
            <h6 className="font-bold mb-[20px] text-white">Resources</h6>
            <ul className="pl-0 list-none">
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/forum')} className="text-white/90 hover:text-neonorange transition-all duration-300">Forum</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/activities')} className="text-white/90 hover:text-neonorange transition-all duration-300">Activities</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/about')} className="text-white/90 hover:text-neonorange transition-all duration-300">About Us</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/contact')} className="text-white/90 hover:text-neonorange transition-all duration-300">Contact</Link>
              </li>
              <li className="mb-[10px]">
                <Link to={getLocalizedPath('/privacy')} className="text-white/90 hover:text-neonorange transition-all duration-300">Privacy Policy</Link>
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="mb-[30px] mb-md-0">
            <h6 className="font-bold mb-[20px] text-white">Download Our App</h6>
            <p className="mb-[20px] text-white/90">Get the full Imigo experience with our mobile app</p>
            <div className="app-buttons flex flex-wrap gap-2">
              <a href="https://apps.apple.com/us/app/imigo-connect/id6744267446" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light">
                <i className="fab fa-apple mr-[5px]"></i> iOS App
              </a>
              <a href="https://play.google.com/store/apps/details?id=app.imigo" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light">
                <i className="fab fa-google-play mr-[5px]"></i> Android App
              </a>
            </div>
          </Col>
        </Row>
        <div className="border-t border-[#444] mt-[30px] pt-[30px] text-center">
          <p className="mb-0">&copy; {new Date().getFullYear()} Imigo. All Rights Reserved.</p>
        </div>
      </Container>
    </footer>
  )
}

export default FooterImigo 